
import * as _ from 'lodash';
import {module} from '../app';

module.service('AjaxService', [
    '$http', '$q', 'localStorage',
    function ($http, $q, localStorage) {

      function buildLocalStorageCacheKey(url) {
        return 'CACHE_REQUEST::' + url;
      }

      function request(options, onSuccess, onError) {
        $http(options).then(onSuccess, onError);
      }

      function loadRealResponse(options, cacheKey, defer) {
        request(options, function (response) {
          if (response.data) {
            let cachedData = {
              data: response.data,
              lastModified: response.headers('Last-Modified')
            };
            localStorage.setObject(cacheKey, cachedData);
          }
          defer.resolve(response.data);
        }, function (error) {
          defer.reject(error);
        });
      }

      let ajaxObj = {
        tokenHeaderValue: {},
        makeAjax: function (options, shouldCacheData) {
          let defer = $q.defer();

          let headers = options.headers || {};
          if (options.auth !== false)
            headers = _.extend(_.cloneDeep(this.tokenHeaderValue), headers);

          options.headers = headers;
          options.contentType = options.contentType || "application/json";

          if (shouldCacheData) {
            let cacheKey = buildLocalStorageCacheKey(options.url);

            let originalMethod = options.method;
            let cachedData = localStorage.getObject(cacheKey);
            if (cachedData != null) {
              options.method = 'HEAD';
              options.headers.IsBackground = true;

              request(options, function (response) {
                if (response.headers('Last-Modified') == cachedData.lastModified) {
                  defer.resolve(cachedData.data);
                } else {
                  options.method = originalMethod;
                  delete options.headers.IsBackground;
                  loadRealResponse(options, cacheKey, defer);
                }
              }, function (error) {
                defer.reject(error);
              });
            } else {
              loadRealResponse(options, cacheKey, defer);
            }
            return defer.promise;
          }

          request(options, function (response) {
            if (options.method == 'HEAD')
              defer.resolve(response);
            else
              defer.resolve(response.data);
          }, function (error) {
            defer.reject(error);
          });

          return defer.promise;
        },
        get: function (url, data, headers, auth, params) {
          return this.makeAjax({
            url: url,
            method: "GET",
            data: data,
            headers: headers,
            auth: auth,
            params: params
          });
        },
        getAndCache: function (url, data, headers, auth, params) {
          return this.makeAjax({
            url: url,
            method: "GET",
            data: data,
            headers: headers,
            auth: auth,
            params: params
          }, true);
        },
        head: function (url, data, headers, auth) {
          headers = headers || {};

          headers.IsBackground = true;

          return this.makeAjax({
            url: url,
            method: "HEAD",
            data: data,
            headers: headers,
            auth: auth
          });
        },
        post: function (url, data, headers) {
          return this.makeAjax({
            url: url,
            method: "POST",
            data: data,
            headers: headers
          });
        },
        put: function (url, data, headers) {
          return this.makeAjax({
            url: url,
            method: "PUT",
            data: data,
            headers: headers
          });
        },
        delete: function (url, headers) {
          return this.makeAjax({
            url: url,
            method: "DELETE",
            headers: headers
          });
        }
      };

      return ajaxObj;
    }

  ]);



// WEBPACK FOOTER //
// ./src/scripts/services/AjaxService.js